// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1d89-","modalFooterButton":"ModalNotes_modalFooterButton__34jgO"};